import template from './nmbButton.template.html';

export default {
  template,
  bindings: {
    idTicket: '<',
    hasPreferredProduct: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, uiService, eventService, lodgementService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {};

      /*
       * NMB ~ Send Application
       * --------------------------------------------------------------------------------
       */
      this.sendApplicationNmb = () => {
        if (!ctrl.hasPreferredProduct) {
          uiService.toast({
            text: {
              p1: 'No recommended product',
              p2: 'was',
              p3: 'selected.'
            },
            warn: true
          });

          return;
        }

        uiService.toast({
          text: {
            p1: 'Sending Application',
            p2: 'to NMB',
            p3: 'Please wait...'
          }
        });

        lodgementService.sendApplicationNmb({ idTicket: ctrl.idTicket }).then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Sending Application',
                p2: 'to NMB',
                p3: 'successful'
              },
              success: true
            });
          } else {
            eventService.lodgementResponseErrors({
              errors: result.errors,
              errorMessage: result.errorMessage,
              provider: ctrl.gateway?.value
            });

            uiService.toast({
              text: {
                p1: result.message
              },
              warn: true
            });
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {};

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = () => {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = () => {};
    }
  }
};
